import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * 合并 Tailwind CSS 类名的工具函数
 * 与 ivymobi 项目保持一致
 *
 * @param inputs - 类名数组或对象
 * @returns 合并后的类名字符串
 *
 * @example
 * cn('tw-flex', 'tw-items-center', { 'tw-gap-4': true })
 * // => 'tw-flex tw-items-center tw-gap-4'
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
